import type { LiveCaption } from '@/pages/Call/hooks/useLiveTranscription'

/** Total words across the captured transcript — drives the "too short" gate. */
export function countTranscriptWords(captions: Pick<LiveCaption, 'text'>[]): number {
  return captions
    .map((c) => c.text)
    .join(' ')
    .split(/\s+/)
    .filter(Boolean).length
}
